module.exports = __webpack_public_path__ + "static/media/undraw-reminders.34daf446.svg";